import { useEffect, useState, useCallback } from "react";
import { toast } from "sonner";
import { api, adminApi } from "../../lib/api";

export const useCrud = (path, blank) => {
  const [items, setItems] = useState([]);
  const load = useCallback(async () => {
    try { const { data } = await api.get(`/${path}`); setItems(Array.isArray(data) ? data : (data.streamers || [])); }
    catch { /* ignore */ }
  }, [path]);
  useEffect(() => { load(); }, [load]);

  const patch = (id, key, val) => setItems((p) => p.map((it) => (it.id === id ? { ...it, [key]: val } : it)));
  const setItem = (id, obj) => setItems((p) => p.map((it) => (it.id === id ? { ...it, ...obj } : it)));

  const add = async () => {
    try { await adminApi.post(`/${path}`, blank); toast.success("Added"); load(); }
    catch { toast.error("Add failed"); }
  };
  const save = async (it) => {
    try { await adminApi.put(`/${path}/${it.id}`, it); toast.success("Saved"); }
    catch { toast.error("Save failed"); }
  };
  const remove = async (id) => {
    try { await adminApi.delete(`/${path}/${id}`); load(); }
    catch { toast.error("Delete failed"); }
  };
  const move = async (idx, dir) => {
    const arr = [...items]; const j = idx + dir;
    if (j < 0 || j >= arr.length) return;
    [arr[idx], arr[j]] = [arr[j], arr[idx]];
    const reordered = arr.map((it, i) => ({ ...it, order: i }));
    setItems(reordered);
    try { await adminApi.post(`/${path}/reorder`, reordered.map((i) => i.id)); toast.success("Order saved"); }
    catch { toast.error("Reorder failed"); load(); }
  };

  return { items, setItems, load, patch, setItem, add, save, remove, move };
};
